import qs from '../../scripts/util/DOM/qs';
import isElem from '../../scripts/util/isElement';
import $ from 'jquery';

const selectors = {
	login: '.js-login',
	page: '.page',
	input: '.login .js-field-input',
	loginForm: '.login-form',
	submitButton: '.js-login .button_type_submit',
	inputResetPassword: '.reset-password .js-field-input',
	socialBtn: '.button--vk-auth',
	submitBtnCl: '.button_type_submit',
	resetPasswordForm: '.js--reset-password-form',
	resetPasswordNotificationModal: '.notification-reset-password-modal'
};

const classes = {
	submitButtonLoading: 'button_type_submit_loading'
};

const addMod = () => {
	const page = qs(selectors.page);
	page.classList.add('page_login_full');
};

const hidePlaceholders = () => {
	$(selectors.input).focus( function () {
		$(this).data('placeholder', $(this).attr('placeholder'));
		$(this).attr('placeholder', '');
	});
	$(selectors.input).blur( function () {
		$(this).attr('placeholder', $(this).data('placeholder'));
	});
};

const submitHandler = () => {
	$(selectors.loginForm).on('submit', function () {
		$(this).find(selectors.submitButton).addClass(classes.submitButtonLoading);
	});

	$(selectors.input).on('focusin', function () {
		const inputError = $(this).closest('.field').find('.field__wrap-input-error');
		$(this).removeClass('field__input_state_error');
		inputError.stop();
		inputError.removeClass('login-form__errors--show').slideUp();
	});

	$(selectors.input).on('focusout', function () {
		$(selectors.loginForm).trigger('validate.csssr');
		const self = $(this);

		if ($(this).hasClass('field__input_state_error')) {
			const error = $(this).data('invalid-message');
			const inputError = $(this).closest('.field').find('.field__wrap-input-error');
			inputError.stop();
			inputError.text(error).addClass('login-form__errors--show').slideDown();
		}

		$(selectors.input).each(function (index, item) {
			if ($(item).hasClass('field__input_state_error') && !$(item).closest('.field').find('.field__wrap-input-error').hasClass('login-form__errors--show') && $(item).attr('name') !== self.attr('name')) {
				$(item).removeClass('field__input_state_error');
			}
		});

	});

	$(selectors.submitButton).on('click', function () {
		const self = this;
		const $inputs = $(selectors.input);
		// const $inputs = $(selectors.inputResetPassword).length ? $(selectors.inputResetPassword) : $(selectors.input);
		setTimeout(function () {
			if ($inputs.length) {
				$inputs.each(function (index, item) {
					if ($(item).hasClass('field__input_state_error')) {
						const error = $(item).data('invalid-message');
						$(item).closest('.field').find('.field__wrap-input-error').text(error).slideDown();
						$(self).removeClass('button_type_submit_loading');
						$(self).prop('disabled', false);
					} else {
						$(self).addClass('button_type_submit_loading');
						$(self).prop('disabled', true);
					}
				});
			}
		}, 300);
	});

};

const socialLogin = () => {
	$(selectors.socialBtn).on('click', async function (e) {
		e.preventDefault();

		if ($(this).hasClass('button--google-auth')) {
			const geoUrl = '/geo-currency';
			let geo = '';
			try {
				const response = await fetch(geoUrl);
				geo = await response.json();
			} catch (error) {
				console.log(error);
			}

			if (geo.country === 'RU') {
				const googleBlockedModalEl = $('.modal__google-auth-blocked');
				googleBlockedModalEl.addClass('modal__google-auth-blocked--visible');

				$('.modal__google-auth-blocked__close').on('click', function () {
					googleBlockedModalEl.removeClass('modal__google-auth-blocked--visible');
				});

				return;
			}
		}

		const socialButton = $(this);
		const btnSubmit = socialButton.closest(selectors.login).find(selectors.submitBtnCl);
		const ajaxErrorMessageEl = socialButton.closest(selectors.login).find('.login-form--fail');
		const errorMessages = {
			accountExists: 'Пользователь с таким адресом электронной почты уже зарегистрирован.',
			socialError: 'Неуспешная попытка авторизации через социальную сеть. Пожалуйста, попробуйте другой метод.',
			default: 'Ошибка при отправке заявки. Пожалуйста, заполните поля заявки еще раз и нажмите кнопку отправить.'
		};
		let dataPurpose = 0;
		if (socialButton.attr('data-purpose')) {
			dataPurpose = socialButton.attr('data-purpose');

			const setCookieRegisterParams = (goal, page) => {
				const d = new Date();
				d.setTime(d.getTime() + (1 * 24 * 60 * 60 * 1000));
				const expires = 'expires=' + d.toUTCString() + ';';
				const domain = 'domain=.' + (document.domain.match(/[^\.]*\.[^.]*$/)[0]) + ';';
				const path = 'path=/;';
				document.cookie = 'registrationGoal' + '=' + goal + '; ' + expires + path + domain;
				document.cookie = 'registerpage' + '=' + page + '; ' + expires + path + domain;
			};
			setCookieRegisterParams(dataPurpose, null);
		}
		btnSubmit.attr('disabled', 'disabled');
		btnSubmit.addClass('is-loading');
		socialButton.addClass('is-disabled');

		ajaxErrorMessageEl.textContent = '';
		ajaxErrorMessageEl.removeClass('show');

		const geoUrl = '/geo-currency';
		let geo = '';
		try {
			const response = await fetch(geoUrl);
			geo = await response.json();
		} catch (error) {
			console.log(error);
		}

		const orderData = {};
		if (geo.country === 'RU') {
			orderData.rubclient = true;
		} else {
			orderData.rubclient = false;
		}
		orderData.totalamount = 125;
		orderData.registration = 'n';
		orderData.orderMode = 'order';
		orderData.mailagree = 'y';
		orderData.discount = 'n';
		orderData.design = '';
		orderData.packageName = 'standard';
		orderData.period = 'year';
		orderData.source = '';
		orderData.password = '';
		orderData.lastname = '';
		orderData._csrf = ''; // eslint-disable-line
		orderData.purpose = dataPurpose;
		orderData.registrationPage = window.location.href;

		const authUrl = socialButton.attr('href');

		$.ajax({
			url: authUrl,
			type: 'POST',
			dataType: 'json',
			data: {
				name: orderData.name,
				packageName: orderData.packageName,
				email: orderData.email,
				period: orderData.period,
				rubclient: orderData.rubclient,
				totalamount: orderData.totalamount,
				registration: orderData.registration,
				orderMode: orderData.orderMode,
				mailagree: orderData.mailagree,
				discount: orderData.discount,
				registrationGoal: orderData.purpose,
				registrationPage: orderData.registrationPage,
				_csrf: '',
				registerpage: orderData.registerpage,
				isMyWedRegistration: false
			},
			xhrFields: {
				withCredentials: true
			},
			success: response => {
				if (response.status !== 'ok') {
					btnSubmit.attr('disabled', false);
					btnSubmit.removeClass('is-loading');
					socialButton.removeClass('is-disabled');
					console.log(response);
				}
				btnSubmit.attr('disabled', false);
				btnSubmit.removeClass('is-loading');
				socialButton.removeClass('is-disabled');

				switch (response.status) {
					case 'ok':
						window.top.location = response.location;
						break;
					case 'create-new-account':
						ajaxErrorMessageEl.textContent = errorMessages.accountExists;
						ajaxErrorMessageEl.addClass('show');
						break;
					case 'social-auth-error':
						ajaxErrorMessageEl.textContent = errorMessages.socialError;
						ajaxErrorMessageEl.addClass('show');
						break;
					default:
						ajaxErrorMessageEl.textContent = errorMessages.default;
						ajaxErrorMessageEl.addClass('show');
						break;
				}
			},
			error: (qXHR, textStatus, errorThrown) => { // eslint-disable-line
				btnSubmit.attr('disabled', false);
				btnSubmit.removeClass('is-loading');
				socialButton.removeClass('is-disabled');
				ajaxErrorMessageEl.textContent = errorMessages.default;
				ajaxErrorMessageEl.addClass('show');
			},
			complete: (qXHR, textStatus) => { // eslint-disable-line
				btnSubmit.attr('disabled', false);
				btnSubmit.removeClass('is-loading');
				socialButton.removeClass('is-disabled');
			}
		});
	});
};

const resetPasswordForm = () => {
	$(selectors.resetPasswordForm).on('submit', function (e) {
		e.preventDefault();
		const form = $(e.target);
		const submitButton = form.find('button[type="submit"]');

		$('.notification-reset-password-modal__button-close').on('click', function () {
			$(selectors.resetPasswordNotificationModal).removeClass('visible');
			submitButton.removeClass('button_type_submit_loading');
			submitButton.prop('disabled', false);
		});


		const email = form.find('#email').val();
		const csrf = form.find('input[name="_csrf"]').val();

		submitButton.addClass('button_type_submit_loading');
		submitButton.prop('disabled', true);

		$.ajax({
			url: '/reset-password',
			type: 'POST',
			data: {email, _csrf: csrf},
			complete: () => {
				$(selectors.resetPasswordNotificationModal).addClass('visible');
				setTimeout(() => {
					submitButton.removeClass('button_type_submit_loading');
					submitButton.prop('disabled', false);
				}, 0);
			}
		});
	});
};



const render = () => {
	if (isElem(selectors.login)) {
		addMod();
		hidePlaceholders();
		submitHandler();
		socialLogin();
		resetPasswordForm();
	}
};

export default render;
